import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { BlockingLoader } from '../components'
import { useGlobalStore } from '../store'

const ProtectedRoute = ({ component: Comp, path, ...rest }) => {
  const { isAuthenticated, isLoading } = useGlobalStore()

  if (isLoading) return <BlockingLoader />

  return (
    <Route
      path={path}
      {...rest}
      render={(props) => {
        let hasAskIa=''
        if(props.location.search.indexOf('?askia=') !== -1){
          // http://localhost:8080/projects?askia=371e3996-0b9a-4271-a813-92926c635c72
          hasAskIa = props.location.search
        }
        return isAuthenticated ? (
          <Comp {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/'+hasAskIa,
              state: {
                prevLocation: path,
                error: 'You need to login first!',
              },
            }}
          />
        )
      }}
    />
  )
}
export default ProtectedRoute
